import { Checkbox } from '@arionbanki/arionui';
import { Markdown } from 'components';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

type ProductListProps = Readonly<{
	disabled?: boolean;
	products: string[] | null;
	selected: string[];
	setSelected: (arr: string[]) => void;
}>;

export function ProductList({ products, selected, ...props }: ProductListProps) {
	const { t } = useContext(AppContext);

	const content = (products || []).map(product => {
		const id = product.toLowerCase();
		return (
			<div className="row my-4 product-panel" key={id}>
				<div className="col-lg-6">
					<Checkbox
						checked={selected.includes(id)}
						disabled={props.disabled}
						id={id}
						label={t(`${id}_title`, 'products')}
						onChange={checked => {
							props.setSelected(checked ? [...selected, id] : selected.filter(x => id !== x));
						}}
					/>
					<p>{t(`${id}_description`, 'products')}</p>
				</div>
				<div className="col-lg-6">
					<Markdown>{t(`${id}_list`, 'products')}</Markdown>
				</div>
			</div>
		);
	});

	return <>{content}</>;
}
